import React, { useCallback } from 'react';
import { push } from 'connected-react-router';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import * as icons from 'mdi-material-ui';

import { useGetInvestmentFundQuery } from 'api/main';
import { texts } from 'utils/languages/fr';

import FundAttributes from './FundAttributes';
import PrivateFunds from './PrivateFunds';
import Tunnels from './Tunnels';
import { Loader } from 'components';
import { Box, Breadcrumbs, Link } from '@mui/material';
import VLManagement from './VLManagement';

const FundDetails = () => {
    const { fundId } = useParams();
    const dispatch = useDispatch();

    const { data: fund, isFetching: fundLoading, refetch } = useGetInvestmentFundQuery(fundId);

    const handleBreadcrumb = useCallback(
        id => e => {
            e.preventDefault();
            if (id) {
                refetch();
            } else {
                dispatch(push('/fund-management'));
            }
        },
        [dispatch, refetch]
    );

    return (
        <Loader loading={fundLoading || !fund} marginTop={20}>
            <Breadcrumbs separator={<icons.MenuRight />} aria-label="breadcrumb">
                <Link underline="hover" href="/" onClick={handleBreadcrumb()}>
                    {texts.FUND_MANAGEMENT}
                </Link>
                <Link underline="hover" href="/" onClick={handleBreadcrumb(fundId)}>
                    {fund?.name}
                </Link>
            </Breadcrumbs>
            <Box paddingX={2} paddingY={1}>
                {fund?.evergreen && <VLManagement key={fundId} fund={fund} />}
                {fund?.private && <PrivateFunds fund={fund} />}
                <FundAttributes fund={fund} refetch={refetch} />
                <Tunnels fund={fund} refetch={refetch} />
            </Box>
        </Loader>
    );
};

export default FundDetails;
